var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showScreenLoader)?_c('div',{staticClass:"loading loading-label"},[_vm._v("…")]):_vm._e(),_vm._v(" "),(_vm.showScreenLoader)?_c('p',{staticClass:"text-center loading-text"},[_vm._v(_vm._s(_vm.screenLoaderText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }